/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ngx-gallery.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './ngx-gallery-image.component.ngfactory';
import * as i3 from 'ngx-gallery/lib/ngx-gallery-image.component';
import * as i4 from 'ngx-gallery/lib/ngx-gallery-helper.service';
import * as i5 from './ngx-gallery-thumbnails.component.ngfactory';
import * as i6 from 'ngx-gallery/lib/ngx-gallery-thumbnails.component';
import * as i7 from '@angular/platform-browser';
import * as i8 from '@angular/common';
import * as i9 from 'ngx-gallery/lib/ngx-gallery.component';
import * as i10 from './ngx-gallery-preview.component.ngfactory';
import * as i11 from 'ngx-gallery/lib/ngx-gallery-preview.component';
const styles_NgxGalleryComponent:any[] = [i0.styles];
export const RenderType_NgxGalleryComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NgxGalleryComponent,data:{}});
function View_NgxGalleryComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-image',
      ([] as any[]),[[4,'height',(null as any)]],[[(null as any),'onClick'],[(null as any),
          'onActiveChange'],[(null as any),'mouseenter'],[(null as any),'mouseleave']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onMouseEnter()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onMouseLeave()) !== false);
          ad = (pd_1 && ad);
        }
        if (('onClick' === en)) {
          const pd_2:any = ((<any>_co.openPreview($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('onActiveChange' === en)) {
          const pd_3:any = ((<any>_co.select($event)) !== false);
          ad = (pd_3 && ad);
        }
        return ad;
      },i2.View_NgxGalleryImageComponent_0,i2.RenderType_NgxGalleryImageComponent)),
      i1.ɵdid(638976,(null as any),0,i3.NgxGalleryImageComponent,[i1.ElementRef,i4.NgxGalleryHelperService],
          {images:[0,'images'],clickable:[1,'clickable'],selectedIndex:[2,'selectedIndex'],
              arrows:[3,'arrows'],arrowsAutoHide:[4,'arrowsAutoHide'],swipe:[5,'swipe'],
              animation:[6,'animation'],size:[7,'size'],arrowPrevIcon:[8,'arrowPrevIcon'],
              arrowNextIcon:[9,'arrowNextIcon']},{onClick:'onClick',onActiveChange:'onActiveChange'})],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = _co.mediumImages;
        const currVal_2:any = _co.currentOptions.preview;
        const currVal_3:any = _co.selectedIndex;
        const currVal_4:any = _co.currentOptions.imageArrows;
        const currVal_5:any = _co.currentOptions.imageArrowsAutoHide;
        const currVal_6:any = _co.currentOptions.imageSwipe;
        const currVal_7:any = _co.currentOptions.imageAnimation;
        const currVal_8:any = _co.currentOptions.imageSize;
        const currVal_9:any = _co.currentOptions.arrowPrevIcon;
        const currVal_10:any = _co.currentOptions.arrowNextIcon;
        _ck(_v,1,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,
            currVal_8,currVal_9,currVal_10);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.getImageHeight();
        _ck(_v,0,0,currVal_0);
      });
}
function View_NgxGalleryComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-thumbnails',
      ([] as any[]),[[4,'marginTop',(null as any)],[4,'marginBottom',(null as any)],
          [4,'height',(null as any)]],[[(null as any),'onActiveChange'],[(null as any),
          'mouseenter'],[(null as any),'mouseleave'],['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onMouseEnter()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onMouseLeave()) !== false);
          ad = (pd_1 && ad);
        }
        if (('window:resize' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,1).onResize()) !== false);
          ad = (pd_2 && ad);
        }
        if (('onActiveChange' === en)) {
          const pd_3:any = ((<any>_co.select($event)) !== false);
          ad = (pd_3 && ad);
        }
        return ad;
      },i5.View_NgxGalleryThumbnailsComponent_0,i5.RenderType_NgxGalleryThumbnailsComponent)),
      i1.ɵdid(573440,(null as any),0,i6.NgxGalleryThumbnailsComponent,[i7.DomSanitizer,
          i1.ElementRef,i4.NgxGalleryHelperService],{images:[0,'images'],columns:[1,
          'columns'],rows:[2,'rows'],arrows:[3,'arrows'],arrowsAutoHide:[4,'arrowsAutoHide'],
          margin:[5,'margin'],selectedIndex:[6,'selectedIndex'],clickable:[7,'clickable'],
          swipe:[8,'swipe'],size:[9,'size'],arrowPrevIcon:[10,'arrowPrevIcon'],arrowNextIcon:[11,
              'arrowNextIcon']},{onActiveChange:'onActiveChange'})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = _co.smallImages;
    const currVal_4:any = _co.currentOptions.thumbnailsColumns;
    const currVal_5:any = _co.currentOptions.thumbnailsRows;
    const currVal_6:any = _co.currentOptions.thumbnailsArrows;
    const currVal_7:any = _co.currentOptions.thumbnailsArrowsAutoHide;
    const currVal_8:any = _co.currentOptions.thumbnailMargin;
    const currVal_9:any = _co.selectedIndex;
    const currVal_10:any = (_co.currentOptions.image || _co.currentOptions.preview);
    const currVal_11:any = _co.currentOptions.thumbnailsSwipe;
    const currVal_12:any = _co.currentOptions.thumbnailSize;
    const currVal_13:any = _co.currentOptions.arrowPrevIcon;
    const currVal_14:any = _co.currentOptions.arrowNextIcon;
    _ck(_v,1,1,[currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,
        currVal_10,currVal_11,currVal_12,currVal_13,currVal_14]);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getThumbnailsMarginTop();
    const currVal_1:any = _co.getThumbnailsMarginBottom();
    const currVal_2:any = _co.getThumbnailsHeight();
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_NgxGalleryComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{preview:0}),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),10,'div',([] as any[]),[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgxGalleryComponent_1)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgxGalleryComponent_2)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-preview',([] as any[]),
              [[2,'ngx-gallery-active',(null as any)]],[[(null as any),'onClose'],
                  ['window','keydown']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:i9.NgxGalleryComponent = _v.component;
                if (('window:keydown' === en)) {
                  const pd_0:any = ((<any>i1.ɵnov(_v,10).onKeyDown($event)) !== false);
                  ad = (pd_0 && ad);
                }
                if (('onClose' === en)) {
                  const pd_1:any = ((<any>_co.onClosePreview()) !== false);
                  ad = (pd_1 && ad);
                }
                return ad;
              },i10.View_NgxGalleryPreviewComponent_0,i10.RenderType_NgxGalleryPreviewComponent)),
      i1.ɵdid(573440,[[1,4]],0,i11.NgxGalleryPreviewComponent,[i1.ElementRef,i4.NgxGalleryHelperService],
          {images:[0,'images'],descriptions:[1,'descriptions'],showDescription:[2,
              'showDescription'],swipe:[3,'swipe'],fullscreen:[4,'fullscreen'],forceFullscreen:[5,
              'forceFullscreen'],closeOnClick:[6,'closeOnClick'],closeOnEsc:[7,'closeOnEsc'],
              keyboardNavigation:[8,'keyboardNavigation'],arrowPrevIcon:[9,'arrowPrevIcon'],
              arrowNextIcon:[10,'arrowNextIcon'],closeIcon:[11,'closeIcon'],fullscreenIcon:[12,
                  'fullscreenIcon'],spinnerIcon:[13,'spinnerIcon']},{onClose:'onClose'}),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i9.NgxGalleryComponent = _v.component;
        const currVal_1:any = _co.currentOptions.image;
        _ck(_v,4,0,currVal_1);
        const currVal_2:any = _co.currentOptions.thumbnails;
        _ck(_v,7,0,currVal_2);
        const currVal_4:any = _co.bigImages;
        const currVal_5:any = _co.descriptions;
        const currVal_6:any = _co.currentOptions.previewDescription;
        const currVal_7:any = _co.currentOptions.previewSwipe;
        const currVal_8:any = _co.currentOptions.previewFullscreen;
        const currVal_9:any = _co.currentOptions.previewForceFullscreen;
        const currVal_10:any = _co.currentOptions.previewCloseOnClick;
        const currVal_11:any = _co.currentOptions.previewCloseOnEsc;
        const currVal_12:any = _co.currentOptions.previewKeyboardNavigation;
        const currVal_13:any = _co.currentOptions.arrowPrevIcon;
        const currVal_14:any = _co.currentOptions.arrowNextIcon;
        const currVal_15:any = _co.currentOptions.closeIcon;
        const currVal_16:any = _co.currentOptions.fullscreenIcon;
        const currVal_17:any = _co.currentOptions.spinnerIcon;
        _ck(_v,10,1,[currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,
            currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17]);
      },(_ck,_v) => {
        var _co:i9.NgxGalleryComponent = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'ngx-gallery-layout ',_co.currentOptions.layout,
            '');
        _ck(_v,1,0,currVal_0);
        const currVal_3:any = _co.previewEnabled;
        _ck(_v,9,0,currVal_3);
      });
}
export function View_NgxGalleryComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'ngx-gallery',
      ([] as any[]),[[4,'width',(null as any)],[4,'height',(null as any)],[4,'left',
          (null as any)]],[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onResize()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_NgxGalleryComponent_0,RenderType_NgxGalleryComponent)),i1.ɵprd(4608,(null as any),
      i4.NgxGalleryHelperService,i4.NgxGalleryHelperService,[i1.Renderer]),i1.ɵdid(4571136,
      (null as any),0,i9.NgxGalleryComponent,[i1.ElementRef],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,2).width;
        const currVal_1:any = i1.ɵnov(_v,2).height;
        const currVal_2:any = i1.ɵnov(_v,2).left;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
      });
}
export const NgxGalleryComponentNgFactory:i1.ComponentFactory<i9.NgxGalleryComponent> = i1.ɵccf('ngx-gallery',
    i9.NgxGalleryComponent,View_NgxGalleryComponent_Host_0,{options:'options',images:'images'},
    {change:'change'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/ngx-gallery/lib/ngx-gallery.component.ngfactory.ts